interface RecordCollageProps {
  variant?: "home" | "album" | "result" | "cassette";
}

export function RecordCollage({ variant = "home" }: RecordCollageProps) {
  return (
    <figure className={`record-collage record-collage--${variant}`} aria-hidden="true">
      <img src="/record-collage-v2.png" alt="" />
    </figure>
  );
}
